import { Shark, Utils, View } from "shark-mvc";
import moment from "moment";

import templateContent from "./not-compliance-report-edit.html";
import "../../_shark_models/NotComplianceReport";
import NotComplianceReport from "../../_shark_models/NotComplianceReport";
import Document from "../../_shark_models/Document";

import followUpManager from "../../_shark_jaws/managers/followUpManager";
import { communicationManager } from "../../_shark_jaws/managers/communicationManager";
import constructionSiteListView from "./constructionSiteListView";
import { documentManager } from "../../_shark_jaws/managers/documentManager";
import { exportPDFComponent } from "../../_shark_components/exportPDF/exportPDFComponent";
import mainNavComponent from "../../_shark_jaws/components/mainNavComponent";
import { notComplianceReportManager } from "../../_shark_jaws/managers/notComplianceReportManager";
import printButtonComponent from "../../_shark_components/printButton/printButtonComponent";
import waitBoxComponent from "../../_shark_components/waitBox/waitBoxComponent";

class NotComplianceReportEditView extends View {
	constructor() {
		super("notComplianceReportEditView");

		this.setTemplate(templateContent);
	}
	
	afterRender () {
		const currNotComplianceReport = Shark.get("currNotComplianceReport");

		if (!currNotComplianceReport) {
			Shark.openPage(notComplianceReportListView);
			return;
		}

		if (this.get("isEditing")) {
			//Dave: Ti prego, facciamone una funzione
			const inputList = document.querySelectorAll("input");
			inputList.forEach(item => {
				item.disabled = false;
				item.readOnly = false;
				item.classList.remove("form-control-plaintext", "col-form-value");
				item.classList.add("form-control");
			});
			
			const selectList = document.querySelectorAll("select");
			selectList.forEach(item => {
				item.disabled = false;
				item.readOnly = false;
				item.classList.remove("form-control-plaintext", "col-form-value");
				item.classList.add("form-control");
			});
			
			const textareaList = document.querySelectorAll("textarea");
			textareaList.forEach(item => {
				item.disabled = false;
				item.readOnly = false;
				item.classList.remove("form-control-plaintext", "col-form-value");
				item.classList.add("form-control");
			});

			const ipmDisabled = document.querySelectorAll(".ipmDisabled");
			ipmDisabled.forEach(item => {
				item.disabled = true;
				item.readOnly = true;
				item.classList.add("form-control-plaintext", "col-form-value");
				item.classList.remove("form-control");
			});
		}
	}
	
	postSaveOperations () {
		waitBoxComponent.hide();

		const afterSaveDestination = this.get("afterSaveDestination");
		if (afterSaveDestination) {
			const currUser = Shark.get("currUser");
			const currNotComplianceReport = Shark.get("currNotComplianceReport");

			this.set({
				afterSaveDestination: null,
				isEditing: false,
				__editEnabled: currUser.hasPermission("editNotComplianceReportForIPM") && currNotComplianceReport.status !== NotComplianceReport.STATUS_CLOSED,
				__saving: false,
			});
			Shark.openPage(afterSaveDestination);
		}
		else {
			Shark.openPage(constructionSiteListView);
		}
	}

	async saveItemBtn_clickHandler () {
		const currNotComplianceReport = Shark.get("currNotComplianceReport");
		const validationErrors = currNotComplianceReport.validate();

		if (validationErrors.length > 0) {
			alert("Attenzione, si sono verificati i seguenti errori:\n\n" + validationErrors.join("\n"));
		}
		else {
			//Dave: Parte di questo giro è duplicato nel componente del modal di chiusura... non posso recuperare?
			let overrideReason = "";
			const successfullyManaged = currNotComplianceReport.verificationData.successfullyManaged;

			if ([NotComplianceReport.STATUS_WAITING_CS_DETAILS, NotComplianceReport.STATUS_CS_READY_TO_START, NotComplianceReport.STATUS_CS_RUNNING].indexOf(this.get("currNotComplianceReportStartStatus")) > -1 && successfullyManaged !== null) {
				if (!confirm(`Attenzione!\n\nHai indicato che la Non Conformità ${!successfullyManaged ? "non " : ""}è stata risolta in modo efficace, ma c'è un Cantiere legato a questa Non Conformità, sei sicuro di voler procedere?\n\n(dovresti aspettare che l'Agente chiuda il cantiere e, insieme, verrà chiusa anche la Non Conformità)`)) {
					return;
				}

				overrideReason = prompt(`Se sei proprio sicuro di voler procedere anche se il Cantiere non è ancora stato chiuso per favore indica una motivazione:)`);
				if (overrideReason === null || overrideReason.trim() === "") {
					alert("Se vuoi procedere devi inserire una motivazione");
					return;
				}

				overrideReason = ` La chiusura è stata forzata con la seguente motivazione: <q>${overrideReason}</q>`;

				currNotComplianceReport.set({
					conclusionDate: moment(),
					status: NotComplianceReport.STATUS_CLOSED,
				});
			}

			if (([NotComplianceReport.STATUS_OPEN].indexOf(this.get("currNotComplianceReportStartStatus")) > -1 && successfullyManaged !== null) || overrideReason !== "") {
				const newFollowUp = Shark.getInstance("ClientFollowUp", {
					body: `Il Rapporto di non Conformità <strong>${currNotComplianceReport.__numberLabel}</strong> è stato chiuso, la Non Conformità è stata risolta in modo <strong>${!successfullyManaged ? "non " : ""}efficace</strong>.${overrideReason}`,
					clientGuid: currNotComplianceReport.clientGuid,
					referenceGuid: currNotComplianceReport.guid,
					referenceType: "notComplianceReport",
					status: 3,
					type: "system"
				});

				followUpManager.save(newFollowUp);

				currNotComplianceReport.set({
					conclusionDate: moment(),
					status: NotComplianceReport.STATUS_CLOSED,
				});
			}
			else {
				const newFollowUp = Shark.getInstance("ClientFollowUp", {
					body: `Il Rapporto di non Conformità <strong>${currNotComplianceReport.__numberLabel}</strong> è stato modificato.`,
					clientGuid: currNotComplianceReport.clientGuid,
					referenceGuid: currNotComplianceReport.guid,
					referenceType: "notComplianceReport",
					status: 3,
					type: "system"
				});

				followUpManager.save(newFollowUp);
			}

			this.set({
				__saving: true
			});
			Shark.render();
			console.log(currNotComplianceReport);
			waitBoxComponent.show();

			const notComplianceAttachments = [];
			currNotComplianceReport.notComplianceData.attachments.forEach(item => {
				if (item.guid === "" && item instanceof Document) {
					// Dave: Perché facevo questo doppio passaggio??? Se è un Document è inutile che lo esporto e lo converto in un Document
					// notComplianceAttachments.push(Shark.getInstance("Document", item.export()));
					notComplianceAttachments.push(item);
				}
			});
			currNotComplianceReport.notComplianceData.attachments = currNotComplianceReport.notComplianceData.attachments.filter(item => item.guid !== "");

			const warrantyAttachments = [];
			currNotComplianceReport.warrantyData.attachments.forEach(item => {
				if (item.guid === "" && item instanceof Document) {
					// Dave: Perché facevo questo doppio passaggio??? Se è un Document è inutile che lo esporto e lo converto in un Document
					// warrantyAttachments.push(Shark.getInstance("Document", item.export()));
					warrantyAttachments.push(item);
				}
			});
			currNotComplianceReport.warrantyData.attachments = currNotComplianceReport.warrantyData.attachments.filter(item => item.guid !== "");

			notComplianceReportManager.save(currNotComplianceReport)
			.then(async saveResponse => {
				console.log({saveResponse});

				if (saveResponse.requestedAction === "insert") {
					alert("ATTENZIONE, si è verificato un errore, per favore segnalare il codice 'NCR-102'");
				}
				else {
					const currConstructionSite = Shark.get("currConstructionSite");
					const currUser = Shark.get("currUser");

					//Dave: Tutto replicato, ottimizza, ma tanto va messo altrove perché deve essere uguale per tutti gli ITEM;

					if (notComplianceAttachments.length > 0) {
						notComplianceAttachments.forEach(document => {
							document.set({
								folderGuid: currNotComplianceReport.attachmentFolderGuid,
								tags: [currNotComplianceReport.__numberLabel, "Causa non conformità"],
							});
						});
	
						await documentManager.save2(notComplianceAttachments)
						.then(saveNotComplianceAttachmentsResponse => {
							notComplianceAttachments.forEach(item => {
								currNotComplianceReport.notComplianceData.attachments.push(item.export("attachmentPreview"));
							});
						});
					}

					if (warrantyAttachments.length > 0) {
						warrantyAttachments.forEach(document => {
							document.set({
								folderGuid: currNotComplianceReport.attachmentFolderGuid,
								tags: [currNotComplianceReport.__numberLabel, "Richiesta attivazione garanzia"],
							});
						});

						await documentManager.save2(warrantyAttachments)
						.then(saveWarrantyAttachmentsResponse => {
							warrantyAttachments.forEach(item => {
								currNotComplianceReport.warrantyData.attachments.push(item.export("attachmentPreview"));
							});
						});
					}

					notComplianceReportManager.save(currNotComplianceReport);
					currNotComplianceReport.parseAttachments();

					if (currNotComplianceReport.__deletedAttachmentGuids) {
						documentManager.delete2(currNotComplianceReport.__deletedAttachmentGuids.map(item => {return {guid: item}}))
						.then(deleteAttachmentsResponse => {
							console.log({deleteAttachmentsResponse})
						});
					}

					//DAve!!! Se ci vengo dalla lista generica non ho un currConstructionSite!!!
					if (currConstructionSite) {
						communicationManager.notComplianceReportUpdateIPM(currUser, currConstructionSite, currNotComplianceReport)
						.then(response => {
							notComplianceReportEditView.postSaveOperations();
						});
					}
					else {
						notComplianceReportEditView.postSaveOperations();
					}
				}
				/********************************************************************/
			});
		}
	}









	
	addUsedProductBtn_clickHandler () {
		const currNotComplianceReport = Shark.get("currNotComplianceReport");

		const newSpoiledProduct = Shark.getInstance("__smart__", {
			customStorageType: "",
			lot: "",
			product: "",
			storageType: 0,
			__index: currNotComplianceReport.spoiledProductList.length
		});

		currNotComplianceReport.spoiledProductList.push(newSpoiledProduct);
		Shark.render();
	}

	backToListBtn_clickHandler () {
		const currNotComplianceReport = Shark.get("currNotComplianceReport");

		if (!currNotComplianceReport.isDirty() || (currNotComplianceReport.isDirty() && confirm("Sei sicuro di voler annullare? Le modifiche effettuate saranno perse."))) {
			const afterSaveDestination = this.get("afterSaveDestination");
			if (afterSaveDestination) {
				this.set({
					afterSaveDestination: null,
					isEditing: false,
				});
				Shark.openPage(afterSaveDestination);
			}
			else {
				Shark.openPage(constructionSiteListView);
			}
		}
	}

	beforeLoad () {
		window.scroll(0, 0);
		const currUser = Shark.get("currUser");
		let currNotComplianceReport = Shark.get("currNotComplianceReport");

		if (!currNotComplianceReport) {
			currNotComplianceReport = Shark.getInstance("NotComplianceReport");
			Shark.set({currNotComplianceReport});
		}

		this.set({
			__editEnabled: currUser.hasPermission("editNotComplianceReportForIPM") && currNotComplianceReport.status !== NotComplianceReport.STATUS_CLOSED,
			__htmlTitle: "Modifica Rapporto di Non Conformità | IPM HUB",
		});

		exportPDFComponent.set("documentSaveName", "Rapporto di non conformità - " + currNotComplianceReport.__numberLabel.replace("/", "-") + " - " + currNotComplianceReport.clientName + " - " + currNotComplianceReport.siteLocation.name + " - " + currNotComplianceReport.siteLocation.interventionAreas);
		exportPDFComponent.set("documentToExport", currNotComplianceReport);

		this.set("currNotComplianceReportStartStatus", currNotComplianceReport.status);
	}

	beforeRender () {
		this.set({
			__nextNotComplianceAttachmentSaveName: Shark.__generateGUID(),
			__nextWarrantyAttachmentSaveName: Shark.__generateGUID(),
		});
	}

	cancelEditsBtn_clickHandler () {
		const currNotComplianceReport = Shark.get("currNotComplianceReport");

		if (!currNotComplianceReport.isDirty() || (currNotComplianceReport.isDirty() && confirm("Sei sicuro di voler annullare? Le modifiche effettuate saranno perse."))) {
			Shark.set("currNotComplianceReport", null);
			
			const cancelDestination = this.get("cancelDestination");
			if (cancelDestination) {
				this.set({
					cancelDestination: null,
					isEditing: false,
				});
				Shark.openPage(cancelDestination);
			}
			else {
				Shark.openPage(constructionSiteListView);
			}
		}
	}

	deleteAttachmentBtn_clickHandler (event, data) {
		const currNotComplianceReport = Shark.get("currNotComplianceReport");

		if (currNotComplianceReport) {
			//Dave: Questo dovrebbe essere il comportamento predefinito di SmartModel.get()
			const newAttachmentList = Utils.getDeepProperty(currNotComplianceReport, data.container).filter(item => item.guid !== data.guid);
			currNotComplianceReport.set(data.container, newAttachmentList);

			if (currNotComplianceReport.__deletedAttachmentGuids) {
				currNotComplianceReport.__deletedAttachmentGuids.push(data.guid);
			}
			else {
				currNotComplianceReport.__deletedAttachmentGuids = [data.guid];
			}
			
			console.log({newAttachmentList, __deletedAttachmentGuids: currNotComplianceReport.__deletedAttachmentGuids});
			Shark.render();
		}
	}

	editBtn_clickHandler () {
		this.set({
			isEditing: true,
		});
		Shark.render();
	}

	init () {
		this.addComponents([exportPDFComponent, mainNavComponent, printButtonComponent, waitBoxComponent]);
	}

	uploadedNotCompliance_changeHandler (event) {
		waitBoxComponent.show();
		const currNotComplianceReport = Shark.get("currNotComplianceReport");

		documentManager.upload(event.target)
		.then(uploadDocumentResponse => {
			uploadDocumentResponse.data.documents.forEach(document => {
				document.set({
					folderGuid: currNotComplianceReport.attachmentFolderGuid,
					source: "notComplianceReportCause",
				});
			})

			currNotComplianceReport.notComplianceData.attachments.push(...uploadDocumentResponse.data.documents);

			console.log({currNotComplianceReport, uploadDocumentResponse});
			waitBoxComponent.hide();
			Shark.render();
		});

		// notComplianceReportManager.uploadAttachment(event.target, "notComplianceData")
		// .then(uploadResponse => {
		// 	Shark.render();
		// });
	}

	uploadNotComplianceBtn_clickHandler (event) {
		document.querySelector("#uploadedNotCompliance").click();
	}

	uploadedWarranty_changeHandler (event) {
		waitBoxComponent.show();
		const currNotComplianceReport = Shark.get("currNotComplianceReport");

		documentManager.upload(event.target)
		.then(uploadDocumentResponse => {
			uploadDocumentResponse.data.documents.forEach(document => {
				document.set({
					folderGuid: currNotComplianceReport.attachmentFolderGuid,
					source: "notComplianceReportWarranty",
				});
			})

			currNotComplianceReport.warrantyData.attachments.push(...uploadDocumentResponse.data.documents);

			console.log({currNotComplianceReport, uploadDocumentResponse});
			waitBoxComponent.hide();
			Shark.render();
		});
	}

	uploadWarrantyBtn_clickHandler (event) {
		document.querySelector("#uploadedWarranty").click();
	}
}

const notComplianceReportEditView = new NotComplianceReportEditView();

Shark.registerView(notComplianceReportEditView);

export { notComplianceReportEditView };
